import "core-js/modules/es.array.concat.js";
export default (function (_ref) {
  var request = _ref.request;
  return {
    deviceItemLogQuery: function deviceItemLogQuery(deviceId, year, data) {
      return request({
        url: "/iot/deviceItemTLog/".concat(deviceId, "/").concat(year),
        method: 'get',
        params: data
      });
    },
    deviceLogQuery: function deviceLogQuery(deviceId, data) {
      return request({
        url: "/iot/deviceLog/".concat(deviceId),
        method: 'get',
        params: data
      });
    }
  };
});